export const downloadFile = (url: string, filename: string = "document") => {
  fetch(url).then(function (t) {
    return t.blob().then((b) => {
      var a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.setAttribute("download", filename);
      a.click();
      a.remove();
    });
  });
};

export default downloadFile;
